import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-manual",
  "use": "icon-user-manual-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-user-manual\"><path d=\"M13 2H3c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2m1 10a1 1 0 0 1-1 1H8V3h5a1 1 0 0 1 1 1z\" /><path d=\"M9 5h4v1H9zm0 2.5h4v1H9zM9 10h4v1H9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol